"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const React = __importStar(require("react"));
const layouts_1 = require("../shared/layouts");
const useProcess_1 = require("./useProcess");
const Process = () => {
    const { isProcessing } = (0, useProcess_1.useProcess)();
    return (React.createElement(layouts_1.SplitWrapper, null,
        React.createElement("div", null, isProcessing && (React.createElement("div", { className: "sui-text-center loading-page-content sui-my-4" },
            React.createElement(teamsnap_ui_1.Loader, { type: "pulse", size: { height: 16, width: 16 } }))))));
};
exports.default = Process;
